import React, { useEffect, useState } from 'react'
import Teamimage from './Images/Team.svg'
import facebook from './Images/facebook.png'
import insta from './Images/insta.png'
import linkdin from './Images/linkdin.svg'
import axios from 'axios'
import { RxCross2 } from 'react-icons/rx'
import { FaCheckCircle } from 'react-icons/fa'
interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
  Facebook:string;
  Linkedin:string;
  number:number;
}
const BoardofDirectors = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [newData, setNewData] = useState<UserStructure[]>([]);
    const[openForm, setOpenForm] = useState<Boolean>(false);
const[receiverNumber, setReceiverNumber] = useState(Number);
  const [isSubmitted, setIsSubmitted] = useState<boolean | null>(null);
  const [isFlipped, setIsFlipped] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [selectedMethod, setSelectedMethod] = useState('sms');
    const [mobile, setMobile] = useState('');
    const [countryCode, setCountryCode] = useState('+91');
    const[otpgenerated, setotpgenerated]  = useState('');
  
    
    function generateOTP(length = 6): string {
    const digits = '0123456789';
    let otp = '';
    for (let i = 0; i < length; i++) {
      otp += digits[Math.floor(Math.random() * 10)];
    }
    return otp;
  }
  useEffect(() => {
      const gtop = generateOTP();
      setotpgenerated(gtop);
    }, []);
  const sendOtp = async () => {
  try {
    const fullNumber = `${countryCode}${mobile}`;
    const fullWhatsappNumber = `91${mobile}`;

    // Send SMS OTP
    const smsPromise = axios.post(`${process.env.REACT_APP_API_URL}/auth/send-otp`, {
      number: mobile,
      otp: otpgenerated,
    });

    // Send WhatsApp OTP
    const whatsappPromise = axios.post(`${process.env.REACT_APP_API_URL}/auth/send-whatsapp-otp`, {
      number: fullWhatsappNumber,
      otp: otpgenerated,
    });

    // Wait for both requests
    const [smsRes, whatsappRes] = await Promise.all([smsPromise, whatsappPromise]);

    if (smsRes.data.success || whatsappRes.data.success) {
      setOtpSent(true);
      alert('OTP sent successfully');
    } else {
      alert('OTP failed to send on both platforms');
    }
  } catch (err) {
    alert('Failed to send OTP');
    console.error(err);
  }
};
  
    const verifyOtp = async () => {
      try {
        
        if (otp===otpgenerated) {
          setIsOtpVerified(true);
          alert('OTP verified');
        } else {
          alert('Invalid OTP');
        }
      } catch (err) {
        alert('OTP verification failed');
      }
    };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(
          `${api}/auth/allusersinfo`
        );

        setNewData(response.data);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  const sendMessage = async (number: number, message: string) => {
    try {
      const response = await axios.post(`${api}/auth/sendwhatsapp`,
        {
          number,
          message,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      alert('Message sent successfully!');
      console.log('Message sent successfully:', response.data);
    } catch (e: any) {
      console.error('Error sending message:', e.response?.data || e.message);
      alert('Failed to send the message.');
    }
  };
 
  
  const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  
    // Example form data collection
    const formData = new FormData(event.currentTarget);
    setIsSubmitted(true);
  
    try {
      const response = await axios.post(`${api}/auth/sendwhatsapp2`,
        {
          senderName: formData.get('name'),
          senderMobile: formData.get('mobile'),
          senderEmail:formData.get('email'), 
          number:receiverNumber,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      setIsSubmitted(true);
      setIsFlipped(true);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        
        console.error('Error submitting contact form:', error.response?.data?.message || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      setIsSubmitted(false);
      setIsFlipped(true);
    }
  
    
  };


  const closeform = ()=>{
    setOpenForm(false);
    setIsSubmitted(false);
  }

    return (
        <div>
          <div className="bg-[#1E2A3A] py-14 px-[8%] ">
            <div className="flex flex-wrap w-[100%] justify-between ">
              <div className=" sm:w-[50%]">
                <span className="text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
                RMB Jaipur 
                </span>
                <span className="text-[#FDBC12] text-[39px] leading-10	font-bold pl-2	">
                Leadership Team 
                </span>
              </div>
            </div>
            <div>
            <div>
          <div className="w-[100%] flex flex-wrap justify-between mt-[70px] gap-y-10 ">
          {newData.filter((items)=>items.role === 'Leader').map((data, index) =>(
            <div className=" flex flex-wrap lg:w-[48%] w-[100%] gap-4">
            <div className=" w-[200px] h-[200px] p-3 border-2 border-[#FDBC12] rounded-full flex justify-center items-center">
                <img className=" w-full h-full rounded-full object-cover" src={`${api}/${data.profile}`} alt="" />
            </div>
            <div className=" sm:w-[60%] w-[100%] flex flex-col justify-center sm:mt-0 mt-4">
            <h5 className="sm:text-[24px] text-[18px] font-semibol text-[#F5F5F5]">{data.name}</h5>
            <p className="text-[14px] font-semibol text-[#D7D3D2]">{data.designation}</p>
            <div className="w-[171px] h-[2px] bg-[#FDBC12] mt-5"></div>
            <p className="text-[12px] text-[#94A2B8] mt-5 min-h-[95px]">{data.company_name}</p>
            <div className="flex items-center mt-3">   <img className="w-[24px] h-[24px] " src={facebook} alt="" />
            <img className="w-[24px] h-[24px] ml-4" src={insta} alt="" onClick={()=>{
              window.location.href=`${data.Facebook}`
            }}/>
            <img className="w-[24px] h-[24px]  ml-4" src={linkdin} alt="" onClick={()=>{
              window.location.href=`${data.Linkedin}`
            }} />
            <button className="bg-[#FDBC12] w-[150px] py-2 rounded text-[#101729] text-[12px] font-normal ml-4"
           onClick={()=>{setReceiverNumber(data.number);setOpenForm(!openForm)}}
            >
            Connect With Me
            </button>

            </div>
            </div>
           
         
          </div>
          ))}
          </div>
        </div>
        {openForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div
                    className={`bg-white p-10 rounded-lg w-[530px] h-auto relative transform ${
                      isSubmitted ? "rotate-y-180" : ""
                    } transition-transform duration-500`}
                  >
                    {!isSubmitted ? (
                      <>
                        <h2 className="text-2xl font-medium mb-8">Connect with us</h2>
                        <form onSubmit={handleFormSubmit}>
                          <label className="block mb-2">
                            Full Name:
                            <input
                              type="text"
                              className="w-full border p-2 rounded mt-1"
                              name="fullName"
                              required
                            />
                          </label>
                          <label className="block mb-2">
                            Email:
                            <input
                              type="email"
                              className="w-full border p-2 rounded mt-1"
                              name="email"
                              required
                            />
                          </label>
                        <label className="block mb-2">
              Mobile No.:
              <div className="flex mt-1">
                <select
  name="countryCode"
  className="border p-2 rounded-l w-[140px] bg-white text-sm"
  onChange={(e) => setCountryCode(e.target.value)}
  required
>
  <option value="+93">Afghanistan (+93)</option>
  <option value="+355">Albania (+355)</option>
  <option value="+213">Algeria (+213)</option>
  <option value="+1-684">American Samoa (+1-684)</option>
  <option value="+376">Andorra (+376)</option>
  <option value="+244">Angola (+244)</option>
  <option value="+1-264">Anguilla (+1-264)</option>
  <option value="+672">Antarctica (+672)</option>
  <option value="+1-268">Antigua and Barbuda (+1-268)</option>
  <option value="+54">Argentina (+54)</option>
  <option value="+374">Armenia (+374)</option>
  <option value="+297">Aruba (+297)</option>
  <option value="+61">Australia (+61)</option>
  <option value="+43">Austria (+43)</option>
  <option value="+994">Azerbaijan (+994)</option>
  <option value="+1-242">Bahamas (+1-242)</option>
  <option value="+973">Bahrain (+973)</option>
  <option value="+880">Bangladesh (+880)</option>
  <option value="+1-246">Barbados (+1-246)</option>
  <option value="+375">Belarus (+375)</option>
  <option value="+32">Belgium (+32)</option>
  <option value="+501">Belize (+501)</option>
  <option value="+229">Benin (+229)</option>
  <option value="+1-441">Bermuda (+1-441)</option>
  <option value="+975">Bhutan (+975)</option>
  <option value="+591">Bolivia (+591)</option>
  <option value="+387">Bosnia and Herzegovina (+387)</option>
  <option value="+267">Botswana (+267)</option>
  <option value="+55">Brazil (+55)</option>
  <option value="+246">British Indian Ocean Territory (+246)</option>
  <option value="+1-284">British Virgin Islands (+1-284)</option>
  <option value="+673">Brunei (+673)</option>
  <option value="+359">Bulgaria (+359)</option>
  <option value="+226">Burkina Faso (+226)</option>
  <option value="+257">Burundi (+257)</option>
  <option value="+855">Cambodia (+855)</option>
  <option value="+237">Cameroon (+237)</option>
  <option value="+1">Canada (+1)</option>
  <option value="+238">Cape Verde (+238)</option>
  <option value="+1-345">Cayman Islands (+1-345)</option>
  <option value="+236">Central African Republic (+236)</option>
  <option value="+235">Chad (+235)</option>
  <option value="+56">Chile (+56)</option>
  <option value="+86">China (+86)</option>
  <option value="+61">Christmas Island (+61)</option>
  <option value="+61">Cocos Islands (+61)</option>
  <option value="+57">Colombia (+57)</option>
  <option value="+269">Comoros (+269)</option>
  <option value="+682">Cook Islands (+682)</option>
  <option value="+506">Costa Rica (+506)</option>
  <option value="+385">Croatia (+385)</option>
  <option value="+53">Cuba (+53)</option>
  <option value="+599">Curacao (+599)</option>
  <option value="+357">Cyprus (+357)</option>
  <option value="+420">Czech Republic (+420)</option>
  <option value="+243">Democratic Republic of the Congo (+243)</option>
  <option value="+45">Denmark (+45)</option>
  <option value="+253">Djibouti (+253)</option>
  <option value="+1-767">Dominica (+1-767)</option>
  <option value="+1-809">Dominican Republic (+1-809)</option>
  <option value="+593">Ecuador (+593)</option>
  <option value="+20">Egypt (+20)</option>
  <option value="+503">El Salvador (+503)</option>
  <option value="+240">Equatorial Guinea (+240)</option>
  <option value="+291">Eritrea (+291)</option>
  <option value="+372">Estonia (+372)</option>
  <option value="+251">Ethiopia (+251)</option>
  <option value="+500">Falkland Islands (+500)</option>
  <option value="+298">Faroe Islands (+298)</option>
  <option value="+679">Fiji (+679)</option>
  <option value="+358">Finland (+358)</option>
  <option value="+33">France (+33)</option>
  <option value="+594">French Guiana (+594)</option>
  <option value="+689">French Polynesia (+689)</option>
  <option value="+241">Gabon (+241)</option>
  <option value="+220">Gambia (+220)</option>
  <option value="+995">Georgia (+995)</option>
  <option value="+49">Germany (+49)</option>
  <option value="+233">Ghana (+233)</option>
  <option value="+350">Gibraltar (+350)</option>
  <option value="+30">Greece (+30)</option>
  <option value="+299">Greenland (+299)</option>
  <option value="+1-473">Grenada (+1-473)</option>
  <option value="+590">Guadeloupe (+590)</option>
  <option value="+1-671">Guam (+1-671)</option>
  <option value="+502">Guatemala (+502)</option>
  <option value="+44-1481">Guernsey (+44-1481)</option>
  <option value="+224">Guinea (+224)</option>
  <option value="+245">Guinea-Bissau (+245)</option>
  <option value="+592">Guyana (+592)</option>
  <option value="+509">Haiti (+509)</option>
  <option value="+504">Honduras (+504)</option>
  <option value="+852">Hong Kong (+852)</option>
  <option value="+36">Hungary (+36)</option>
  <option value="+354">Iceland (+354)</option>
  <option value="+91" selected>India (+91)</option>
  <option value="+62">Indonesia (+62)</option>
  <option value="+98">Iran (+98)</option>
  <option value="+964">Iraq (+964)</option>
  <option value="+353">Ireland (+353)</option>
  <option value="+44">Isle of Man (+44)</option>
  <option value="+972">Israel (+972)</option>
  <option value="+39">Italy (+39)</option>
  <option value="+225">Ivory Coast (+225)</option>
  <option value="+1-876">Jamaica (+1-876)</option>
  <option value="+81">Japan (+81)</option>
  <option value="+44-1534">Jersey (+44-1534)</option>
  <option value="+962">Jordan (+962)</option>
  <option value="+7">Kazakhstan (+7)</option>
  <option value="+254">Kenya (+254)</option>
  <option value="+686">Kiribati (+686)</option>
  <option value="+383">Kosovo (+383)</option>
  <option value="+965">Kuwait (+965)</option>
  <option value="+996">Kyrgyzstan (+996)</option>
  <option value="+856">Laos (+856)</option>
  <option value="+371">Latvia (+371)</option>
  <option value="+961">Lebanon (+961)</option>
  <option value="+266">Lesotho (+266)</option>
  <option value="+231">Liberia (+231)</option>
  <option value="+218">Libya (+218)</option>
  <option value="+423">Liechtenstein (+423)</option>
  <option value="+370">Lithuania (+370)</option>
  <option value="+352">Luxembourg (+352)</option>
  <option value="+853">Macau (+853)</option>
  <option value="+389">North Macedonia (+389)</option>
  <option value="+261">Madagascar (+261)</option>
  <option value="+265">Malawi (+265)</option>
  <option value="+60">Malaysia (+60)</option>
  <option value="+960">Maldives (+960)</option>
  <option value="+223">Mali (+223)</option>
  <option value="+356">Malta (+356)</option>
  <option value="+692">Marshall Islands (+692)</option>
  <option value="+596">Martinique (+596)</option>
  <option value="+222">Mauritania (+222)</option>
  <option value="+230">Mauritius (+230)</option>
  <option value="+262">Mayotte (+262)</option>
  <option value="+52">Mexico (+52)</option>
  <option value="+691">Micronesia (+691)</option>
  <option value="+373">Moldova (+373)</option>
  <option value="+377">Monaco (+377)</option>
  <option value="+976">Mongolia (+976)</option>
  <option value="+382">Montenegro (+382)</option>
  <option value="+1-664">Montserrat (+1-664)</option>
  <option value="+212">Morocco (+212)</option>
  <option value="+258">Mozambique (+258)</option>
  <option value="+95">Myanmar (+95)</option>
  <option value="+264">Namibia (+264)</option>
  <option value="+674">Nauru (+674)</option>
  <option value="+977">Nepal (+977)</option>
  <option value="+31">Netherlands (+31)</option>
  <option value="+599">Netherlands Antilles (+599)</option>
  <option value="+687">New Caledonia (+687)</option>
  <option value="+64">New Zealand (+64)</option>
  <option value="+505">Nicaragua (+505)</option>
  <option value="+227">Niger (+227)</option>
  <option value="+234">Nigeria (+234)</option>
  <option value="+683">Niue (+683)</option>
  <option value="+850">North Korea (+850)</option>
  <option value="+1-670">Northern Mariana Islands (+1-670)</option>
  <option value="+47">Norway (+47)</option>
  <option value="+968">Oman (+968)</option>
  <option value="+92">Pakistan (+92)</option>
  <option value="+680">Palau (+680)</option>
  <option value="+970">Palestine (+970)</option>
  <option value="+507">Panama (+507)</option>
  <option value="+675">Papua New Guinea (+675)</option>
  <option value="+595">Paraguay (+595)</option>
  <option value="+51">Peru (+51)</option>
  <option value="+63">Philippines (+63)</option>
  <option value="+48">Poland (+48)</option>
  <option value="+351">Portugal (+351)</option>
  <option value="+1-787">Puerto Rico (+1-787)</option>
  <option value="+974">Qatar (+974)</option>
  <option value="+242">Republic of the Congo (+242)</option>
  <option value="+262">Reunion (+262)</option>
  <option value="+40">Romania (+40)</option>
  <option value="+7">Russia (+7)</option>
  <option value="+250">Rwanda (+250)</option>
  <option value="+590">Saint Barthelemy (+590)</option>
  <option value="+290">Saint Helena (+290)</option>
  <option value="+1-869">Saint Kitts and Nevis (+1-869)</option>
  <option value="+1-758">Saint Lucia (+1-758)</option>
  <option value="+590">Saint Martin (+590)</option>
  <option value="+508">Saint Pierre and Miquelon (+508)</option>
  <option value="+1-784">Saint Vincent and the Grenadines (+1-784)</option>
  <option value="+685">Samoa (+685)</option>
  <option value="+378">San Marino (+378)</option>
  <option value="+239">Sao Tome and Principe (+239)</option>
  <option value="+966">Saudi Arabia (+966)</option>
  <option value="+221">Senegal (+221)</option>
  <option value="+381">Serbia (+381)</option>
  <option value="+248">Seychelles (+248)</option>
  <option value="+232">Sierra Leone (+232)</option>
  <option value="+65">Singapore (+65)</option>
  <option value="+421">Slovakia (+421)</option>
  <option value="+386">Slovenia (+386)</option>
  <option value="+677">Solomon Islands (+677)</option>
  <option value="+252">Somalia (+252)</option>
  <option value="+27">South Africa (+27)</option>
  <option value="+82">South Korea (+82)</option>
  <option value="+211">South Sudan (+211)</option>
  <option value="+34">Spain (+34)</option>
  <option value="+94">Sri Lanka (+94)</option>
  <option value="+249">Sudan (+249)</option>
  <option value="+597">Suriname (+597)</option>
  <option value="+268">Swaziland (+268)</option>
  <option value="+46">Sweden (+46)</option>
  <option value="+41">Switzerland (+41)</option>
  <option value="+963">Syria (+963)</option>
  <option value="+886">Taiwan (+886)</option>
  <option value="+992">Tajikistan (+992)</option>
  <option value="+255">Tanzania (+255)</option>
  <option value="+66">Thailand (+66)</option>
  <option value="+670">Timor-Leste (+670)</option>
  <option value="+228">Togo (+228)</option>
  <option value="+690">Tokelau (+690)</option>
  <option value="+676">Tonga (+676)</option>
  <option value="+1-868">Trinidad and Tobago (+1-868)</option>
  <option value="+216">Tunisia (+216)</option>
  <option value="+90">Turkey (+90)</option>
  <option value="+993">Turkmenistan (+993)</option>
  <option value="+1-649">Turks and Caicos Islands (+1-649)</option>
  <option value="+688">Tuvalu (+688)</option>
  <option value="+256">Uganda (+256)</option>
  <option value="+380">Ukraine (+380)</option>
  <option value="+971">United Arab Emirates (+971)</option>
  <option value="+44">United Kingdom (+44)</option>
  <option value="+1">United States (+1)</option>
  <option value="+598">Uruguay (+598)</option>
  <option value="+998">Uzbekistan (+998)</option>
  <option value="+678">Vanuatu (+678)</option>
  <option value="+58">Venezuela (+58)</option>
  <option value="+84">Vietnam (+84)</option>
  <option value="+681">Wallis and Futuna (+681)</option>
  <option value="+212">Western Sahara (+212)</option>
  <option value="+967">Yemen (+967)</option>
  <option value="+260">Zambia (+260)</option>
  <option value="+263">Zimbabwe (+263)</option>
</select>

                <input
                  type="tel"
                  name="mobile"
                  required
                  className="w-full border p-2 rounded-r"
                  placeholder="Enter mobile number"
                  onChange={(e) => setMobile(e.target.value)}
                />
              </div>
            </label>
             <label className="block mb-2 text-red-500">
                          Verify Via SMS & WhatsApp
                          <div className="flex gap-4 mt-1 hidden">
          <label className="flex items-center gap-1 text-sm text-gray-700">
            <input
              type="radio"
              name="otpMethod"
              value="sms"
              checked={selectedMethod === 'sms'}
              onChange={() => setSelectedMethod('sms')}
            />
            SMS
          </label>
          <label className="flex items-center gap-1 text-sm text-gray-700">
            <input
              type="radio"
              name="otpMethod"
              value="whatsapp"
              checked={selectedMethod === 'whatsapp'}
              onChange={() => setSelectedMethod('whatsapp')}
            />
            WhatsApp
          </label>
        </div>
      </label>

      {/* Verify Button */}
      <button
        type="button"
        onClick={sendOtp}
        className="bg-[#02256D] text-white px-4 py-2 rounded mt-2"
        disabled={!mobile}
      >
        Verify Number
      </button>

      {/* OTP Input Field */}
      {otpSent && !isOtpVerified && (
        <div className="mt-4 flex items-center gap-3">
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
            className="border p-2 rounded w-full"
            placeholder="Enter OTP"
          />
          <button
            type="button"
            onClick={verifyOtp}
            className="bg-green-600 text-white px-4 py-2 rounded"
          >
            Verify
          </button>
        </div>
      )}

      {/* Tick if Verified */}
      {isOtpVerified && (
        <div className="mt-2 text-green-500 flex items-center gap-2">
          <FaCheckCircle className="text-lg" /> Verified
        </div>
      )}

                  <button className="bg-[#02256D] w-full text-white font-medium py-2 rounded mt-6"  disabled={!isOtpVerified} type="submit">
                    Submit
                  </button>
                          
                          <button
                            className="bg-slate-100 ml-2 p-1 rounded-full w-auto flex justify-center items-center text-slate-900 font-[16px] h-auto absolute top-4 right-4"
                            type="button"
                            onClick={() => setOpenForm(false)}
                          >
                            <RxCross2 />
                          </button>
                        </form>
                      </>
                    ) : (
                      <div className=" inset-0 bg-white rotate-y-180 transition-transform duration-500 p-4 text-center flex justify-center items-center h-[232px] ">
                        
                          <div className="text-green-400">
                          <h3 className="text-3xl font-semibold ">Thank you for your submission!</h3>
        <p className="text-sm text-gray-600 mt-4 mb-6">We will get back to you soon. In the meantime, feel free to explore our website for more information. If you need urgent assistance, don’t hesitate to contact us directly.</p>
        
        
                            <button
                              onClick={closeform}
                              className="mt-4 bg-[#02256D] text-white py-2 px-4 rounded"
                            >
                              Return to Home
                            </button>
                          </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
}

export default BoardofDirectors